module.exports = __webpack_public_path__ + "img/medicalappointment.2e0090c5.png";